<ion-content [fullscreen]="true">
  <div class="sign-in-wrap">
    <div class="form-wrap">
      <div class="language-toggle-container">
        <ion-button mode="md" fill="outline" class="language-toggle" (click)="toggleLanguage()">
          {{ selectedLanguage() | uppercase }}
        </ion-button>
      </div>

      <div class="logo-img-wrap">
        <img src="logo-blue.svg" alt="Logo" class="logo-img" />
      </div>

      <form [formGroup]="signUpForm" (ngSubmit)="onSubmit()">
        <!-- Email -->
        <ion-item>
          <ion-input
            type="email"
            [label]="'AUTH.SIGN_UP.EMAIL' | translate"
            labelPlacement="floating"
            formControlName="email"></ion-input>
        </ion-item>

        <ion-item *ngIf="email?.invalid && email?.touched" lines="none">
          <ion-text color="danger">
            <p>{{ "AUTH.SIGN_UP.EMAIL_REQUIRED" | translate }}</p>
          </ion-text>
        </ion-item>

        <!-- Name -->
        <ion-item>
          <ion-input
            type="text"
            [label]="'AUTH.SIGN_UP.NAME' | translate"
            labelPlacement="floating"
            formControlName="name"></ion-input>
        </ion-item>

        <ion-item *ngIf="name?.invalid && name?.touched" lines="none">
          <ion-text color="danger">
            <p>{{ "AUTH.SIGN_UP.NAME_REQUIRED" | translate }}</p>
          </ion-text>
        </ion-item>

        <!-- Password -->
        <ion-item>
          <ion-input
            [type]="showPassword() ? 'text' : 'password'"
            [label]="'AUTH.SIGN_UP.PASSWORD' | translate"
            labelPlacement="floating"
            formControlName="password"></ion-input>
          <ion-icon
            class="extra-small"
            slot="end"
            [name]="showPassword() ? 'eye' : 'eye-off'"
            (click)="togglePassword()"></ion-icon>
        </ion-item>

        <ion-item *ngIf="password?.invalid && password?.touched" lines="none">
          <ion-text color="danger">
            <p>{{ "AUTH.SIGN_UP.PASSWORD_REQUIRED" | translate }}</p>
          </ion-text>
        </ion-item>

        <!-- Repeat Password -->
        <ion-item>
          <ion-input
            [type]="showPassword() ? 'text' : 'password'"
            [label]="'AUTH.SIGN_UP.REPEAT_PASSWORD' | translate"
            labelPlacement="floating"
            formControlName="confirmPassword"></ion-input>
          <ion-icon
            class="extra-small"
            slot="end"
            [name]="showPassword() ? 'eye' : 'eye-off'"
            (click)="togglePassword()"></ion-icon>
        </ion-item>

        <ion-item *ngIf="passwordMismatch() && confirmPassword?.touched" lines="none">
          <ion-text color="danger">
            <p>{{ "AUTH.SIGN_UP.PASSWORD_MISMATCH" | translate }}</p>
          </ion-text>
        </ion-item>

        <!-- Terms and Privacy Agreement -->
        <ion-item lines="none" class="terms-checkbox-item">
          <ion-checkbox
            formControlName="agreeToTerms"
            slot="start">
          </ion-checkbox>
          <ion-label class="terms-label">
            {{ "AUTH.SIGN_UP.I_AGREE_TO" | translate }}
            <a href="#" (click)="openTerms($event)">{{ "AUTH.SIGN_UP.TERMS" | translate }}</a>
            {{ "AUTH.SIGN_UP.AND" | translate }}
            <a href="#" (click)="openPrivacy($event)">{{ "AUTH.SIGN_UP.PRIVACY_POLICY" | translate }}</a>
          </ion-label>
        </ion-item>

        <ion-item *ngIf="agreeToTerms?.invalid && agreeToTerms?.touched" lines="none">
          <ion-text color="danger">
            <p>{{ "AUTH.SIGN_UP.TERMS_REQUIRED" | translate }}</p>
          </ion-text>
        </ion-item>

        <!-- Sign Up Button -->
        <ion-button class="sign-up-btn" expand="block" type="submit" [disabled]="signUpForm.invalid">
          {{ "AUTH.SIGN_UP.SUBMIT" | translate }}
        </ion-button>

        <div class="have-account-wrap">
          <h4 class="signup-text">
            {{ "AUTH.SIGN_UP.HAVE_ACCOUNT" | translate }}
            <a routerLink="/login/sign-in">{{ "AUTH.SIGN_UP.SIGN_IN" | translate }}</a>
          </h4>
        </div>
      </form>
    </div>
  </div>
</ion-content>
